(function () {
  'use strict';

  var pathLocale = window.location.pathname.match(/^\/(de|fr|it)(?:\/|$)/i);
  var locale = pathLocale
    ? pathLocale[1].toLowerCase()
    : (document.documentElement.lang || '').toLowerCase().slice(0, 2);

  if (['de', 'fr', 'it'].indexOf(locale) === -1) return;

  function normalise(value) {
    return String(value || '')
      .replace(/[’‘]/g, "'")
      .replace(/\s+/g, ' ')
      .trim()
      .toLocaleLowerCase(locale);
  }

  function allCaps(value) {
    var letters = String(value || '').replace(/[^A-Za-zÀ-ÖØ-öø-ÿÄÖÜäöü]/g, '');
    return letters.length > 1 && letters === letters.toLocaleUpperCase(locale);
  }

  var exact = {
    de: {
      'dein passwort': 'Ihr Passwort',
      'bist du der shop-inhaber?': 'Sind Sie der Shop-Inhaber?',
      'danke für deine anmeldung': 'Vielen Dank für Ihre Anmeldung',
      'wenn du dich für eine auswahl entscheidest, wird die seite komplett aktualisiert.': 'Wenn Sie eine Auswahl treffen, wird die Seite vollständig aktualisiert.',
      'bitte beachte, dass kommentare vor der veröffentlichung freigegeben werden müssen.': 'Bitte beachten Sie, dass Kommentare vor der Veröffentlichung freigegeben werden müssen.',
      'hinterlasse einen kommentar': 'Kommentar hinterlassen',
      'dein kommentar wurde erfolgreich gepostet! vielen dank!': 'Ihr Kommentar wurde erfolgreich veröffentlicht. Vielen Dank!',
      'dein kommentar wurde erfolgreich gepostet. da unser blog moderiert wird, werden wir ihn erst kurze zeit später veröffentlichen.': 'Ihr Kommentar wurde erfolgreich übermittelt. Nach der Moderation wird er veröffentlicht.',
      'name deiner kategorie': 'Name Ihrer Kollektion',
      'in deinem bereich ansehen': 'In Ihrem Raum ansehen',
      '"ansicht in deinem raum" lädt den artikel in ein augmented-reality-fenster': '„Ansicht in Ihrem Raum“ öffnet den Artikel in Augmented Reality.',
      'danke, dass du uns kontaktiert hast. wir werden uns so schnell wie möglich bei dir melden.': 'Vielen Dank, dass Sie uns kontaktiert haben. Wir melden uns so schnell wie möglich bei Ihnen.',
      'bitte passe folgendes an:': 'Bitte passen Sie Folgendes an:',
      'dein warenkorb': 'Ihr Warenkorb',
      'dein warenkorb ist leer': 'Ihr Warenkorb ist leer',
      'beim aktualisieren deines warenkorbs ist ein fehler aufgetreten. bitte versuche es erneut.': 'Beim Aktualisieren Ihres Warenkorbs ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
      'hast du ein konto?': 'Haben Sie ein Konto?',
      'logge dich ein': 'Melden Sie sich an',
      'verwende weniger filter oder': 'Verwenden Sie weniger Filter oder',
      'entferne alle': 'Alle entfernen',
      'erstelle ein passwort, um dein konto zu aktiveren.': 'Erstellen Sie ein Passwort, um Ihr Konto zu aktivieren.',
      'bist du sicher, dass du diese adresse löschen möchtest?': 'Möchten Sie diese Adresse wirklich löschen?',
      'hast du dein passwort vergessen?': 'Haben Sie Ihr Passwort vergessen?',
      'du hast noch keine bestellungen aufgegeben.': 'Sie haben noch keine Bestellungen aufgegeben.',
      'setze dein passwort zurück': 'Setzen Sie Ihr Passwort zurück',
      'wir werden dir eine e-mail zum zurücksetzen deines passworts schicken': 'Wir senden Ihnen eine E-Mail zum Zurücksetzen Ihres Passworts.',
      'wir haben dir eine e-mail mit einem link zum aktualisieren deines passworts geschickt.': 'Wir haben Ihnen eine E-Mail mit einem Link zum Aktualisieren Ihres Passworts gesendet.',
      'dein geschenkgutschein': 'Ihr Geschenkgutschein',
      'kostenloser versand bei bestellungen über chf 120.–.': 'Kostenloser Versand ab CHF 120.–.',
      'bei bestellungen über chf 120.– ist der versand kostenlos.': 'Ab CHF 120.– ist der Versand kostenlos.',
      'für bestellungen bis chf 120.– kostet der standardversand chf 6.95.': 'Unter CHF 120.– kostet der Standardversand CHF 6.95.',
      'die bestellung wird an die beim checkout angegebene lieferadresse versandt.': 'Die Bestellung wird an die an der Kasse angegebene Lieferadresse versandt.',
      'medien {{ index }} in modal öffnen': 'Medium {{ index }} im Dialogfenster öffnen'
    },

    fr: {
      'saisir avec un mot de passe': 'Accéder avec un mot de passe',
      'saisir': 'Accéder',
      'cette boutique sera propulsée par {{ shopify }}': 'Cette boutique fonctionne avec {{ shopify }}',
      'frais d’expédition calculés à l’étape de paiement.': 'Frais de livraison calculés lors du paiement.',
      "frais d'expédition calculés à l'étape de paiement.": 'Frais de livraison calculés lors du paiement.',
      'taxes incluses et frais d’expédition calculés lors du paiement': 'Taxes incluses. Frais de livraison calculés lors du paiement.',
      "taxes incluses et frais d'expédition calculés lors du paiement": 'Taxes incluses. Frais de livraison calculés lors du paiement.',
      'taxes incluses. expédition : chf 4.95.': 'Taxes incluses. Livraison : CHF 6.95; gratuite dès CHF 120.–.',
      'taxes incluses. livraison : chf 4.95.': 'Taxes incluses. Livraison : CHF 6.95; gratuite dès CHF 120.–.',
      'connectez-vous pour payer plus vite.': 'Connectez-vous pour finaliser votre commande plus rapidement.',
      'statut de traitement': "Statut d'expédition",
      'statut de la commande': 'Statut de la commande',
      'livraison standard chf 6.95. livraison gratuite pour les commandes de plus de chf 120.–.': 'Livraison standard CHF 6.95. Livraison gratuite dès CHF 120.–.',
      'la livraison standard coûte chf 6.95 par commande. la livraison est gratuite pour les commandes de plus de chf 120.–.': 'La livraison standard coûte CHF 6.95 par commande. La livraison est gratuite dès CHF 120.–.',
      'la livraison standard coûte chf 6.95 en suisse et au liechtenstein. la livraison est gratuite pour les commandes de plus de chf 120.–.': 'La livraison standard coûte CHF 6.95 en Suisse et au Liechtenstein. La livraison est gratuite dès CHF 120.–.',
      'la livraison standard coûte chf 6.95 par commande, quel que soit le nombre de produits commandés. la livraison est gratuite pour les commandes de plus de chf 120.–.': 'La livraison standard coûte CHF 6.95 par commande, quel que soit le nombre de produits commandés. La livraison est gratuite dès CHF 120.–.'
    },

    it: {
      'accedi al negozio utilizzando la password:': 'Acceda al negozio con la password:',
      'accedi utilizzando la password': 'Accedi con password',
      'sei il proprietario del negozio? accedi qui': 'È il proprietario del negozio? Acceda qui',
      'questo negozio sarà ospitato su {{ shopify }}': 'Questo negozio funziona con {{ shopify }}',
      'il tuo commento è stato pubblicato! grazie!': 'Il Suo commento è stato pubblicato. Grazie!',
      'il tuo commento è stato pubblicato. lo pubblicheremo fra poco, il nostro blog è soggetto a moderazione.': 'Il Suo commento è stato inviato. Sarà pubblicato dopo la moderazione.',
      'controlla l’ortografia o usa parole o frasi diverse.': 'Controlli l’ortografia o provi parole o frasi diverse.',
      "controlla l'ortografia o usa parole o frasi diverse.": 'Controlli l’ortografia o provi parole o frasi diverse.',
      'correggi i seguenti errori:': 'Corregga i seguenti errori:',
      'si è verificato un errore durante l’aggiornamento del carrello. riprova più tardi.': 'Si è verificato un errore durante l’aggiornamento del carrello. Riprovi più tardi.',
      "si è verificato un errore durante l'aggiornamento del carrello. riprova più tardi.": 'Si è verificato un errore durante l’aggiornamento del carrello. Riprovi più tardi.',
      'imposte incluse. spedizione: chf 4.95.': 'Imposte incluse. Spedizione: CHF 6.95; gratuita da CHF 120.–.',
      'crea una password per attivare il tuo account.': 'Crei una password per attivare il Suo account.',
      'inserisci una nuova password per {{ email }}': 'Inserisca una nuova password per {{ email }}',
      'siano spiacenti ma non possiamo offrirti un metodo di pagamento adatto.': 'Siamo spiacenti, ma non possiamo offrirLe un metodo di pagamento adatto.',
      'siamo spiacenti ma non possiamo offrirti un metodo di pagamento adatto.': 'Siamo spiacenti, ma non possiamo offrirLe un metodo di pagamento adatto.',
      'spedizione standard chf 6.95. spedizione gratuita per ordini superiori a chf 120.–.': 'Spedizione standard CHF 6.95. Spedizione gratuita da CHF 120.–.',
      'la spedizione standard costa chf 6.95 per ordine. la spedizione è gratuita per ordini superiori a chf 120.–.': 'La spedizione standard costa CHF 6.95 per ordine. La spedizione è gratuita da CHF 120.–.',
      'la spedizione standard costa chf 6.95 in svizzera e liechtenstein. la spedizione è gratuita per ordini superiori a chf 120.–.': 'La spedizione standard costa CHF 6.95 in Svizzera e Liechtenstein. La spedizione è gratuita da CHF 120.–.',
      'la spedizione standard costa chf 6.95 per ordine, indipendentemente dal numero di prodotti ordinati. la spedizione è gratuita per ordini superiori a chf 120.–.': 'La spedizione standard costa CHF 6.95 per ordine, indipendentemente dal numero di prodotti ordinati. La spedizione è gratuita da CHF 120.–.',
      'l’ordine viene spedito all’indirizzo indicato al momento del checkout.': 'L’ordine viene spedito all’indirizzo indicato al momento del pagamento.',
      "l'ordine viene spedito all'indirizzo indicato al momento del checkout.": 'L’ordine viene spedito all’indirizzo indicato al momento del pagamento.'
    }
  };

  function replaceText(raw) {
    if (!raw || !raw.trim()) return raw;
    var trimmed = raw.trim();
    var key = normalise(trimmed);
    var replacement = exact[locale][key];
    var adjusted = replacement || trimmed;

    if (locale === 'de') {
      adjusted = adjusted
        .replace(/^Erhöhe die Menge für (.+)$/i, 'Menge für $1 erhöhen')
        .replace(/^Verringere die Menge für (.+)$/i, 'Menge für $1 verringern')
        .replace(/^Du kannst deinem Warenkorb nur (.+) Stück dieses Artikels hinzufügen\.$/i, 'Sie können Ihrem Warenkorb nur $1 Stück dieses Artikels hinzufügen.')
        .replace(/^Hier ist dein Geschenkgutschein im Wert von (.+) für (.+)!$/i, 'Hier ist Ihr Geschenkgutschein im Wert von $1 für $2!')
        .replace(/Kostenloser Versand bei Bestellungen über CHF 120\.–/g, 'Kostenloser Versand ab CHF 120.–')
        .replace(/Bei Bestellungen über CHF 120\.– ist der Versand kostenlos\./g, 'Ab CHF 120.– ist der Versand kostenlos.')
        .replace(/beim Checkout/g, 'an der Kasse');
    }

    if (locale === 'fr') {
      adjusted = adjusted
        .replace(/\b4\.8\b/g, '4,8')
        .replace(/\b4\.9\b/g, '4,9')
        .replace(/\b4\.84\b/g, '4,84')
        .replace(/pour les commandes de plus de CHF 120\.–/gi, 'dès CHF 120.–')
        .replace(/commandes de plus de CHF 120\.–/gi, 'commandes dès CHF 120.–')
        .replace(/frais d['’]expédition/gi, 'frais de livraison');
    }

    if (locale === 'it') {
      adjusted = adjusted
        .replace(/\b4\.8\b/g, '4,8')
        .replace(/\b4\.9\b/g, '4,9')
        .replace(/\b4\.84\b/g, '4,84')
        .replace(/^Puoi aggiungere soltanto (.+) di questo articolo al tuo carrello\.$/i, 'Può aggiungere soltanto $1 di questo articolo al Suo carrello.')
        .replace(/^Qui c['’]è il tuo buono regalo del valore di (.+) per (.+)!$/i, 'Ecco il Suo buono regalo del valore di $1 per $2!')
        .replace(/^Scansiona per utilizzare il buono regalo$/i, 'Scansioni il codice per utilizzare il buono regalo')
        .replace(/per ordini superiori a CHF 120\.–/gi, 'da CHF 120.–')
        .replace(/ordini superiori a CHF 120\.–/gi, 'ordini da CHF 120.–')
        .replace(/al momento del check-out/gi, 'al momento del pagamento')
        .replace(/al check-out/gi, 'al pagamento')
        .replace(/al momento del checkout/gi, 'al momento del pagamento')
        .replace(/al checkout/gi, 'al pagamento')
        .replace(/nel tuo spazio/gi, 'nel Suo spazio');
    }

    if (adjusted === trimmed) return raw;

    var leading = (raw.match(/^\s*/) || [''])[0];
    var trailing = (raw.match(/\s*$/) || [''])[0];
    if (allCaps(trimmed)) adjusted = adjusted.toLocaleUpperCase(locale);
    return leading + adjusted + trailing;
  }

  function processText(node) {
    if (!node || !node.nodeValue || !node.parentElement) return;
    if (/^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/.test(node.parentElement.tagName)) return;
    var updated = replaceText(node.nodeValue);
    if (updated !== node.nodeValue) node.nodeValue = updated;
  }

  function processElement(element) {
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return;
    ['placeholder', 'aria-label', 'title'].forEach(function (attribute) {
      if (!element.hasAttribute(attribute)) return;
      var current = element.getAttribute(attribute);
      var updated = replaceText(current);
      if (updated !== current) element.setAttribute(attribute, updated);
    });
  }

  function run(root) {
    var scope = root && root.nodeType ? root : document.body;
    if (!scope) return;

    if (scope.nodeType === Node.TEXT_NODE) {
      processText(scope);
      return;
    }

    processElement(scope);
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(processText);

    if (scope.querySelectorAll) {
      scope.querySelectorAll('[placeholder], [aria-label], [title]').forEach(processElement);
    }
  }

  function init() {
    run(document.body);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  var queued = false;
  var observer = new MutationObserver(function (mutations) {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') processText(mutation.target);
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE) run(node);
        });
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
